module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in Held status due to a <b>manual hold</b> that will keep it in a held status until it is manually released. </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once released you will no longer be able to edit the order. </div> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/order/html/editHeldOrderModal.html
// module id = 297
// module chunks = 1